import React from "react";
import Clip from "../assets/mortarboard-svgrepo-com.svg";

const Notificationbar = () => {
  return (
    <div className="marquee-section style-header">
      <div className="mycustom-marque header-marque theme-blue-bg">
        <div className="scrolling-wrap">
          <div className="comm">
            <div></div>
            <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/ios/50/parliament.png"
                alt="parliament"
              />
              Recognized & Appreciated by Rana Sikandar Hayat, Minister for
              School Education at the time of launching
            </div>
            {/* 
            <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/windows/32/admission.png"
                alt="exam"
              />
              Final Evaluation Test for Lahore-based candidates (including
              nearby areas) who selected Lahore as their exam city will be held
              on 12 July, 2026 at the CHEP Department, Punjab University.
            </div>
            */}
            {/* <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/material-rounded/24/marker.png"
                alt="location"
              />
              Applications are now open for Physical Classes in Lahore. Apply
              now to secure your seat.
            </div> */}
            {/* Repeated for scrolling marquee loop */}
            <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/ios/50/parliament.png"
                alt="parliament"
              />
              Recognized & Appreciated by Rana Sikandar Hayat, Minister for
              School Education at the time of launching
            </div>
            {/* 
            <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/windows/32/admission.png"
                alt="exam"
              />
              Final Evaluation Test for Lahore-based candidates (including
              nearby areas) who selected Lahore as their exam city will be held
              on 12 July, 2026 at the CHEP Department, Punjab University.
            </div>
            */}
            {/* <div className="cmn-textslide">
              <img
                className="white-icon"
                width="30"
                height="30"
                src="https://img.icons8.com/material-rounded/24/marker.png"
                alt="location"
              />
              Applications are now open for Physical Classes in Lahore. Apply
              now to secure your seat.
            </div> */}
          </div>
        </div>

        {/* Add CSS for white icons */}
        <style jsx>{`
          .white-icon {
            filter: brightness(0) invert(1);
            vertical-align: middle;
            margin-right: 8px;
          }
          .cmn-textslide {
            display: flex;
            align-items: center;
          }
        `}</style>
      </div>
    </div>
  );
};

export default Notificationbar;
